var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgNotificationsIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.375 16.4062H5.625C5.625 16.602 5.65506 16.791 5.7109 16.9688C5.82949 17.3463 6.06436 17.6732 6.37431 17.9062C6.68716 18.1415 7.0765 18.2812 7.5 18.2812C7.91969 18.2812 8.30832 18.1415 8.62166 17.9062C8.93211 17.6732 9.16866 17.3463 9.28828 16.9688C9.3446 16.791 9.375 16.602 9.375 16.4062ZM15 15.4688V14.5312L13.125 12.6562V7.96875C13.125 5.09063 11.5875 2.68125 8.90625 2.04375V1.40625C8.90625 0.628125 8.27812 0 7.5 0C6.72188 0 6.09375 0.628125 6.09375 1.40625V2.04375C3.40313 2.68125 1.875 5.08125 1.875 7.96875V12.6562L0 14.5312V15.4688H15ZM2.68382 13.9688H12.3162L11.625 13.2776V7.96875C11.625 5.61507 10.4119 3.94354 8.55928 3.50307L7.50185 3.25165L6.43958 3.50334C4.57968 3.94401 3.375 5.60436 3.375 7.96875V13.2776L2.68382 13.9688Z",
    fill: "#222222"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNotificationsIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/notifications_icon.52156b50.svg";
export { ForwardRef as ReactComponent };